<div class="custom-loader-dialog-wrap">

  <!-- Processing State -->
  <div class="card" *ngIf="state === 'loading'">
    <div class="loader-header">
      <div class="loader-header-left">
        <div class="spin-icon"></div>
        <span class="loader-title">{{ loaderTitle }}</span>
      </div>
      <span class="loader-count">{{ completedSteps.length }} of {{ steps.length }} completed</span>
    </div>

    <div class="progress-label-row">
      <span class="progress-label">Pipeline commit rate</span>
      <span class="progress-pct">{{ progressPct }}%</span>
    </div>
    <div class="progress-track">
      <div class="progress-fill" [style.width.%]="progressPct"></div>
    </div>

    <div class="step-list">
      <div class="step-row" *ngFor="let s of steps; let i = index">
        <div class="step-row-left">
          <div class="step-icon" [class.done]="completedSteps.includes(i)" [class.active]="currentStep === i">
            <svg class="check-svg" *ngIf="completedSteps.includes(i)" viewBox="0 0 12 12">
              <polyline points="2,6 5,9 10,3" />
            </svg>
            <div class="ping-dot" *ngIf="currentStep === i"></div>
            <span *ngIf="!completedSteps.includes(i) && currentStep !== i">{{ i + 1 }}</span>
          </div>
          <span class="step-text" [class.done]="completedSteps.includes(i)" [class.active]="currentStep === i"
            [class.pending]="!completedSteps.includes(i) && currentStep !== i">{{ s }}</span>
        </div>
        <span class="active-badge" *ngIf="currentStep === i">ACTIVE</span>
      </div>
    </div>
  </div>

  <!-- Success State -->
  <div class="card animate-fade-in" *ngIf="state === 'success'">
    <div class="success-center">
      <div class="shield-wrap">
        <svg class="shield-svg" viewBox="0 0 24 24">
          <path d="M12 3L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6L12 3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      </div>
      <div class="success-title">{{ successTitle }}</div>
      <div class="success-sub">{{ successSub }}</div>
    </div>

    <div class="receipt-rows">
      <div class="receipt-row">
        <span class="receipt-label">{{ idLabel }}</span>
        <span class="receipt-val">{{ data.invoiceNumber }}</span>
      </div>
      <div class="receipt-row">
        <span class="receipt-label">CLIENT RECIPIENT</span>
        <span class="receipt-val">{{ data.clientName }}</span>
      </div>
      <div class="receipt-row" *ngIf="data.clientGstin && data.clientGstin !== 'N/A'">
        <span class="receipt-label">CLIENT GSTIN</span>
        <span class="receipt-val">{{ data.clientGstin }}</span>
      </div>

      <div class="receipt-row">
        <span class="receipt-label">SUBTOTAL</span>
        <span class="receipt-val">₹{{ data.taxableSubledger | number:'1.2-2' }}</span>
      </div>
      <div class="receipt-row" *ngIf="data.taxAmount > 0">
        <span class="receipt-label">CGST + SGST / IGST</span>
        <span class="receipt-val">₹{{ data.taxAmount | number:'1.2-2' }}</span>
      </div>
      <div class="receipt-total-row">
        <span>{{ totalLabel }}</span>
        <span>₹{{ data.totalAmount | number:'1.2-2' }}</span>
      </div>
    </div>

    <div class="meta-box">
      <!-- <div class="meta-row">
        <span class="meta-key">HASH TARGET:</span>
        <span class="meta-hash">{{ ledgerHash }}</span>
      </div> -->
      <div class="meta-row">
        <span class="meta-key">TIMESTAMP:</span>
        <span>{{ timestamp }}</span>
      </div>
    </div>

    <button class="btn-new" (click)="onDoneClick()">{{ buttonText }}</button>
  </div>

</div>